module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_viesi_mobile-4238118972ad319c94129017fda8942b.webp";